/**
 * Runs the provided callback when document.body is available.
 * If body is already present, runs immediately.
 * Otherwise, waits for DOMContentLoaded.
 * @param {Function} callback - Function to run when body is ready
 */
const runWhenBodyReady = (callback) => {
  if (document.body) {
    callback()
  } else {
    const onReady = () => {
      if (document.body) {
        callback()
        document.removeEventListener('DOMContentLoaded', onReady)
      }
    }

    document.addEventListener('DOMContentLoaded', onReady)
  }
}

export default runWhenBodyReady
